import { render, staticRenderFns } from "./editNode.vue?vue&type=template&id=5648285e&scoped=true&"
import script from "./editNode.vue?vue&type=script&lang=js&"
export * from "./editNode.vue?vue&type=script&lang=js&"
import style0 from "./editNode.vue?vue&type=style&index=0&id=5648285e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5648285e",
  null
  
)

export default component.exports